import React from 'react';
import { IoAdd } from 'react-icons/io5';

const FloatingIcon = ({ x, y, size = 24, color = "black" }) => {
  const style = {
    zIndex: 50,
    position: 'absolute',
    left: `${x}px`,
    top: `${y}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none'
  };

  return (
    <div style={style}>
      <IoAdd size={size} color={color} />
    </div>
  );
};

export default FloatingIcon;